import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpInterceptor,
} from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { BehaviorSubject, Observable, of, throwError } from "rxjs";
import {
  catchError,
  map,
  shareReplay,
  take,
  tap,
  timeout,
} from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AppSettingModel } from "src/models/app-setting.model";

@Injectable({
  providedIn: "root",
})
export class AppSettingService {
  private appSettingSubject: BehaviorSubject<AppSettingModel>;
  public appSetting$: Observable<AppSettingModel>;
  private readonly API_TIMEOUT = 5000;

  constructor(private http: HttpClient) {
    this.appSettingSubject = new BehaviorSubject<AppSettingModel>(null);
    this.appSetting$ = this.appSettingSubject.asObservable();
  }

  public get value(): AppSettingModel {
    return this.appSettingSubject.value;
  }

  update(appSetting: AppSettingModel) {
    this.appSettingSubject.next(appSetting);
  }

  get(): Observable<Array<AppSettingModel>> {
    return this.http.get(`${environment.apiUrl}app_settings/`) as Observable<
      Array<AppSettingModel>
    >;
  }

  refresh(): void {
    this.appSetting$ = null; // Force un nouveau chargement au prochain appel
  }
}
